import {
	ElementRef,
	Injectable,
	Renderer2,
	RendererStyleFlags2,
} from '@angular/core';

@Injectable()
export class SubscriptionDetailsProvider {
	private readonly PANEL_HEADER = 50;
	private readonly MENU_HEIGHT = 32;
	private readonly FILTER_BAR_HEIGHT = 42;
	private readonly COLUMNS_GAP_PX = 96;
	private readonly PROJECTS_GAP_PX = 88;
	public adjustHeights(elemRef: ElementRef, renderer: Renderer2): void {
		const container = document.querySelector('#app') as HTMLElement | null;

		const footer = document.querySelector('.footer') as HTMLElement | null;

		const header = document.querySelector(
			'.header-group'
		) as HTMLElement | null;

		const pageHeader = elemRef.nativeElement.querySelector('.app-page__header');

		const internalMetadataSection = elemRef.nativeElement.querySelector(
			'.card-internal-metadata'
		);

		const subscriptionColumnsList = document.querySelector(
			'.app-subscription-column-config'
		) as HTMLElement | null;

		const subscriptionConsumedProjectList = elemRef.nativeElement.querySelector(
			'.app-subscription-consumed-project-list'
		);

		if (!container || !header || !pageHeader || !footer) {
			return;
		}

		if (internalMetadataSection && subscriptionColumnsList) {
			const subscriptionColumnListHeight =
				container.offsetHeight -
				header.offsetHeight -
				footer.offsetHeight -
				pageHeader.offsetHeight -
				internalMetadataSection.offsetHeight -
				this.MENU_HEIGHT -
				this.PANEL_HEADER -
				this.COLUMNS_GAP_PX;

			renderer.setStyle(
				subscriptionColumnsList,
				'--max-height-columns',
				`${subscriptionColumnListHeight}px`,
				RendererStyleFlags2.DashCase
			);
		}

		if (subscriptionConsumedProjectList) {
			const subscriptionConsumedProjectListHeight =
				container.offsetHeight -
				header.offsetHeight -
				footer.offsetHeight -
				pageHeader.offsetHeight -
				this.MENU_HEIGHT -
				this.PANEL_HEADER -
				this.FILTER_BAR_HEIGHT -
				this.PROJECTS_GAP_PX;

			renderer.setStyle(
				subscriptionConsumedProjectList,
				'--max-height-projects',
				`${subscriptionConsumedProjectListHeight}px`,
				RendererStyleFlags2.DashCase
			);
		}
	}
}
